import { Position } from "../../models"

export interface Positions {
    jobGroups: Position[]
    workPlaces: Position[]
}

export interface PositionNode {
    position: Position
    children: PositionNode[]
}

export const toPositions = (nodes: PositionNode[]): Positions => {
    const jobGroupNodes = nodes.flatMap(company => company.children)
    return {
        jobGroups: jobGroupNodes.map(node => node.position),
        workPlaces: jobGroupNodes.flatMap(node => node.children.map(child => child.position)),
    }
}
